const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCberryLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525.032 516.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Components"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9e9c32ca-8b32-42d7-a8ad-c5d996e8fe86_5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 380.6485,
    cy: 189.9763,
    r: 48.1225,
    transform: "translate(-22.8442 324.8019) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.3956,
    cy: 144.3957,
    r: 48.1225,
    transform: "translate(-24.8167 258.7083) rotate(-79.0413)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.3004,
    cy: 371.7743,
    r: 48.1225,
    transform: "translate(-197.481 266.7874) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9968,48.2215c-78.1618-15.0798-154.0237,36.2439-169.1036,114.4058-2.3295,12.0742-11.7343,67.1045,29.6733,118.2402l32.4742-36.884c-20.0749-29.5793-17.4824-58.8342-14.896-72.24,10.0532-52.1079,60.6279-86.3237,112.7357-76.2705,52.1078,10.0532,86.3237,60.6279,76.2704,112.7358-7.9071,40.9839-40.8804,70.896-79.9518,76.9131,7.327,14.5076,12.7665,29.8672,16.2383,45.8958,54.628-12.0002,99.7144-55.3782,110.9651-113.6926,15.0798-78.1616-36.2439-154.0237-114.4057-169.1035Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.6261,316.1366c21.2393,30.0249,18.5289,60.3701,15.9333,73.8232-10.0693,52.1914-60.539,86.3408-112.7302,76.2717-59.8381-11.5447-92.9886-74.4138-71.3902-129.6372-8.4525-.4895-16.9686-1.5447-25.5088-3.1926-7.6567-1.4771-15.1254-3.3906-22.3718-5.7107-26.2125,82.2527,24.8751,169.3333,110.1555,185.7864,78.2839,15.1035,153.9935-36.1172,169.097-114.4011,1.2772-6.6201,13.8347-66.051-30.7999-119.7197l-32.3851,36.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,274.2208c-7.0942-14.5491-12.387-30.0417-15.645-46.1331-19.2332,10.9395-42.3207,15.3315-65.7521,10.811-52.1912-10.0693-86.3398-60.5447-76.2704-112.7358,10.0693-52.1912,60.5446-86.3398,112.7357-76.2705,23.4313,4.5208,43.2279,17.1865,57.0109,34.4958,9.0104-13.7244,19.6868-26.136,31.6843-37.0017-20.2543-22.3613-47.6685-38.5891-79.5789-44.7456C93.4551-12.4635,17.7455,38.7572,2.641,117.0467c-15.1046,78.2896,36.1161,153.999,114.4056,169.1035,31.9104,6.1565,63.3939,1.2922,90.5134-11.9294Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCberryLogo);
export default __webpack_public_path__ + "static/media/cberry-logo.e2ce4651d44d1214ca7ce6364124650c.svg";
export { ForwardRef as ReactComponent };